<div class="table-container overflow-auto w-100" (scroll)="onTableScroll($event)"
  [style.max-height.vh]="isMobile ? 60 : 70" (keydown)="onKeyDown($event)">
  <table id="asset-table" [hidden]="assetFields?.length == 0"
    class="table table-striped table-borderless m-0 border-0" [ngClass]="{'table-hover': hasEditAccess}">
    <thead>
      <!-- Header Row -->
      <tr>
        @if (interactable) {
          <th class="select-column p-0 text-center align-middle">
            <input type="checkbox" aria-label="Select all assets" [checked]="selectedAssets.size > 0"
            [disabled]="assetTableRows?.length === 0" (change)="selectAllAssets($event.target.checked)">
          </th>
        }

        <th class="header-cell text-nowrap align-middle" title="Asset ID">
          <div class="d-flex align-items-center gap-1">
            <span class="fw-semibold flex-fill small">Asset ID</span>
            <i (click)="toggleSortByAssetID()"
              [ngClass]="{'ms-1 fa': true, 'fa-caret-down': sortOrder == 'ASC' && !sortByFieldID, 'fa-caret-up': (sortOrder == 'DESC' && !sortByFieldID) || sortByFieldID}"
              class="sort-icon cursor-pointer">
            </i>
          </div>
        </th>

        @for (field of assetFields; track field; let i = $index) {
          <th class="header-cell text-nowrap align-middle"
            [title]="field.name">
            <div class="d-flex align-items-center gap-1">
              <span class="text-truncate fw-semibold flex-fill small">{{field.name}}</span>
                        <i [ngClass]="{
                                'ms-1 fa': true, 
                                'fa-caret-down': sortByFieldID == field.id && sortOrder == 'ASC', 
                                'fa-caret-up': sortByFieldID != field.id || (sortByFieldID == field.id && sortOrder == 'DESC')
                            }" (click)="sortByField(field)" class="sort-icon cursor-pointer">
              </i>
            </div>
          </th>
        }
      </tr>

      <!-- Filter Row -->
      <tr class="filter-row">
        @if (interactable) {
          <th class="select-column p-0 text-center align-middle">
            @if (hasActiveFilters()) {
              <button
                class="clear-all-btn position-relative border-0 rounded-circle d-inline-flex align-items-center justify-content-center"
                (click)="clearAllFilters()" aria-label="Clear all filters" aria-controls="asset-table"
                title="Clear all filters">
                <i class="fa fa-xmark-circle"></i>
                <span
                class="filter-count-badge position-absolute rounded-circle d-flex align-items-center justify-content-center">{{getActiveFilterCount()}}</span>
              </button>
            }
          </th>
        }

        <th>
          <div class="position-relative d-flex align-items-center">
            <input type="number" class="form-control form-control-sm filter-input" [value]="assetIDFilter"
              (input)="filterAssetID($event.target.value)" placeholder="Number"
              aria-label="Filter Asset ID">
              @if (assetIDFilter) {
                <button
                  class="btn btn-sm filter-clear-btn position-absolute border-0 rounded-circle d-flex align-items-center justify-content-center"
                  (click)="clearAssetIDFilter()" title="Clear filter">
                  <i class="fa fa-times"></i>
                </button>
              }
            </div>
          </th>

          @for (field of assetFields; track field; let i = $index) {
            <th>
              <div class="position-relative d-flex align-items-center">
                <!-- Select dropdown for trueFalse, chooseOne, chooseMultiple -->
                @if (field.type === 'trueFalse' || field.type === 'chooseOne' || field.type === 'chooseMultiple') {
                  <select
                    class="form-select form-select-sm filter-input" [value]="filterMap.get(field.id) ?? ''"
                    (change)="filter(field, $event.target.value)" [attr.aria-label]="'Filter ' + field.name">
                    <option value="">All</option>
                    @if (field.type === 'trueFalse') {
                      <option value="true">True</option>
                    }
                    @if (field.type === 'trueFalse') {
                      <option value="false">False</option>
                    }
                    @for (option of field.dropdownOptions; track option) {
                      <option [value]="option">{{option}}</option>
                    }
                  </select>
                }
                <!-- Text/number/date inputs for other types -->
                @if (field.type !== 'trueFalse' && field.type !== 'chooseOne' && field.type !== 'chooseMultiple') {
                  <input
                    [type]="getFilterInputType(field.type)" class="form-control form-control-sm filter-input"
                    [value]="filterMap.get(field.id) ?? ''" (change)="filter(field, $event.target.value)"
                    [placeholder]="getFilterPlaceholder(field.type)" [attr.aria-label]="'Filter ' + field.name">
                }
                @if (filterMap.get(field.id)) {
                  <button
                    class="btn btn-sm filter-clear-btn position-absolute border-0 rounded-circle d-flex align-items-center justify-content-center"
                    (click)="clearFilter(field)" title="Clear filter">
                    <i class="fa fa-times"></i>
                  </button>
                }
              </div>
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of assetTableRows; track row) {
          <tr (click)="openEditAssetPanel(row.assetID)"
            [style.cursor]="hasEditAccess ? 'pointer' : 'auto'">
            @if (interactable) {
              <td class="text-center align-middle" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="selectedAssets.has(row.assetID)"
                  (change)="selectAsset(row.assetID, $event.target.checked)">
                </td>
              }
              <td [title]="row.assetID.toString()">
                <div class="d-flex gap-1 align-items-center">
                  <span>{{row.assetID}}</span>
                  <span>
                    <i class="far fa-clock icon-hover cursor-pointer"
                    (click)="showAssetHistory($event, row.assetID)"></i>
                  </span>
                  @if (isNew(row.assetID)) {
                    <div class="d-flex align-items-center justify-content-center"
                      [style.height]="5">
                      <span class="badge rounded-pill bg-secondary" [style.fontSize]="5"
                        style="user-select: none">
                        New
                      </span>
                    </div>
                  }
                </div>
              </td>
              @for (value of row.values; track value; let i = $index) {
                <td [title]="getCellTooltip(value, i)">
                  <div class="d-flex align-items-center gap-1">
                    @switch (getValueType(i)) {
                      @case ('location') {
                        @if (isANumberArrayValue(value)) {
                          <span class="text-truncate">
                            {{value[0] | number: '1.8-8'}}, {{value[1] | number: '1.8-8'}}
                          </span>
                        }
                      }
                      @case ('chooseMultiple') {
                        <span class="text-truncate">
                          {{ isArray(value) ? value.join(', ') : value }}
                        </span>
                      }
                      @case ('images') {
                        @if (!value || value == '') {
                          <span>No Files Selected</span>
                        }
                        @if (value?.length > 0) {
                          <span>{{value}}</span>
                          <span>
                            <i class="fa-solid fa-file-circle-question text-muted icon-hover cursor-pointer"
                            (click)="openFilesInModal($event, row, i)"></i>
                          </span>
                        }
                      }
                      @case ('files') {
                        @if (!value || value == '') {
                          <span>No Files Selected</span>
                        }
                        @if (value?.length > 0) {
                          <span>{{value}}</span>
                          <span>
                            <i class="fa-solid fa-file-circle-question text-muted icon-hover cursor-pointer"
                            (click)="openFilesInModal($event, row, i)"></i>
                          </span>
                        }
                      }
                      @case ('date') {
                        @if (isADate(value)) {
                          <span>{{value | date: 'MM-dd-yyyy'}}</span>
                        }
                      }
                      @default {
                        <span>{{value}}</span>
                      }
                    }
                  </div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>

      @if (assetTableRows?.length == 0) {
        <div
        class="position-absolute top-50 start-50 translate-middle p-3 fs-5 text-muted">No Entries</div>
      }

      @if (assetEntryCount > assetTableRows?.length) {
        <div
          class="position-absolute top-100 start-50 translate-middle d-flex gap-1 pb-5">
          <button (click)="loadAllAssets()" class="btn btn-primary">Load All</button>
        </div>
      }

      @if (loading) {
        <div class="position-absolute top-50 start-50 translate-middle d-flex gap-1 pb-5">
          @for (x of [].constructor(5); track x) {
            <div class="spinner-grow text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          }
        </div>
      }
    </div>